import React from 'react';

import RadioButton from 'components/RadioButton';
import { PaymentCard } from 'models/paymentCard';
import { cardTypeNormalize } from 'utils/payment';

import PaymentCardFlag from '../PaymentCardFlag';
import { Container, Header } from './styles';

export interface PaymentCardProps {
  onClick?: () => void;
  card?: PaymentCard;
  isSelectable?: boolean;
  isSelected?: boolean;
  iconType?: string;
  placeholder?: string;
  icon?: string;
  title?: string;
}

const PaymentCardItem = ({
  onClick,
  card,
  isSelectable,
  isSelected,
  iconType,
  placeholder,
  icon,
  title,
}: PaymentCardProps) => {
  if (typeof card === 'undefined') {
    if (typeof title !== 'undefined') {
      return (
        <Container>
          <Header onClick={onClick}>
            <Header.Icon src={icon} alt="" />
            <Header.Title>{title}</Header.Title>
            <Header.ArrowIcon empty />
          </Header>
        </Container>
      );
    }
    return (
      <Container>
        <Header onClick={onClick}>
          <Header.Icon src="/images/list-preview-icons/card-disabled.svg" alt="" />
          <Header.Placeholder empty>{placeholder}</Header.Placeholder>
          <Header.ArrowIcon empty />
        </Header>
      </Container>
    );
  }

  let { card_type } = card;
  card_type = cardTypeNormalize(card_type);
  const card_month = card.month < 10 ? `0${card.month}` : `${card.month}`;

  return (
    <Container>
      <Header onClick={onClick}>
        <PaymentCardFlag card={card} />
        <Header.Detail>
          <div>
            <Header.Title>
              {card_type.toUpperCase()} *{card.last_four_digits}
            </Header.Title>
            {card_month} / {card.year}
          </div>
          {card.default_cc ? <Header.DefaultCard /> : null}
        </Header.Detail>
        {isSelectable ? (
          <RadioButton value={`${card.id}`} isChecked={isSelected} />
        ) : iconType === 'empty' ? null : iconType === 'dots' ? (
          <Header.DotsIcon />
        ) : (
          <Header.ArrowIcon />
        )}
      </Header>
    </Container>
  );
};
export default PaymentCardItem;
